<template>
	<Row>
		<Container>
			<div class="lg:grid grid-cols-2">
				<div class="content-title-wrapper lg:pr-[100px]">
					<h2 class="content-title">Forward-Thinking Innovation</h2>
				</div>
				<div class="content-wrapper">
					<div
						v-for="(text, index) in texts"
						:key="index"
						class="text-content-container"
					>
						<div class="texts-container">
							<div class="texts-content">
								<div class="text-content-wrapper">
									<p
										class="text-content-paragraph"
										v-html="text.paragraph"
									></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Container>
	</Row>
</template>
<script>
export default {
	data() {
		return {
			texts: [
				{
					paragraph:
						"StocksToTrade is a leading-edge fintech company that was co-founded in 2012 by world-renowned trader and teacher, Timothy Sykes. Tim is famously known for turning $12,415 into over $7.5 million in profits and turning over 30 regular folks into self-made millionaires"
				},
				{
					paragraph:
						"As a day trader himself, Tim understands the need for a platform designed specifically for day traders. Where they can find breaking news, charting tools, and chat rooms all in one place."
				},
				{
					paragraph:
						"<span class='special-text'>That’s what StocksToTrade delivers. And we don’t stop there…</span>"
				},
				{
					paragraph:
						"Zak Westphal co-founded StocksToTrade with Tim Sykes, and he’s now our dedicated and forward-thinking CEO. With his MBA from the University of Southern California, he’s driving StocksToTrade into the future..."
				},
				{
					paragraph:
						"He constantly delivers new ideas for revolutionary system improvements — including our two proprietary algorithms — and our AI system IRIS plus, ground-breaking tools and innovative ways to educate traders so they get the most out of our platform and their trading.  "
				},
				{
					paragraph:
						"Our radically new approach to trading software and education even garnered the attention of the Nasdaq exchange. On March 12, 2019, our team had the honor of ringing the Nasdaq closing bell."
				}
			]
		};
	}
};
</script>
<style scoped lang="scss">
@use "~/assets/utils.scss" as *;
.content-title {
	font-family: Open Sauce Sans;
	font-size: 36px;
	font-weight: 500;
	line-height: 59px;
	letter-spacing: -0.02em;
	text-align: center;
	margin-bottom: 24px;
	background: linear-gradient(
		90deg,
		rgb(255, 255, 255) 25%,
		rgb(67, 131, 255) 60%,
		rgb(196, 100, 255) 70%,
		rgb(255, 255, 255) 95%
	);
	-webkit-background-clip: text;
	color: transparent;
	background-clip: text;

	@include breakpoint(lg) {
		font-size: 54px;
		text-align: left;
	}
}

.header-container {
	align-items: flex-start;
	text-align: center;
	margin-bottom: 24px;
	position: relative;
	gap: 24px;
}

.text-content-container {
	width: 100%;
}

.texts-container {
	display: block;
	gap: 64px;

	.texts-content {
		.text-content-wrapper {
			.text-content-paragraph {
				font-family: DM Sans;
				font-size: 18px;
				font-weight: 400;
				line-height: 27px;
				letter-spacing: 0px;
				text-align: left;
				margin-bottom: 40px;
				color: $slate-100;
				:deep(.special-text) {
					font-family: Open Sauce Sans;
					font-size: 36px;
					font-weight: 500;
					line-height: 47px;
					letter-spacing: -0.02em;
					text-align: left;
				}
			}
		}
	}
}
</style>
